import React, { Component, MouseEvent, useCallback } from "react";
import Portfolio from "./Portfolio";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PersonalInfo from "../../components/Dashboard/PersonalInfo";
import MyApps from "./MyApps";
import { ProfileUpdatedPopup } from "../Login/owner/EIDAUpdate";
import Strings from "@my-dld/assets/strings";
import PropertyServices from "./Portfolio/PropertyServices";
import { navigate } from "@my-dld/utils/StoreUtils";
import MyRequestsServices from "./MyRequest";
import { getAppServices } from "@10x/coreapp";
import FreeholdPropertiesPopUp from "./FreeholdProperties/FreeholdPropertiesPopUp";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { propertiesId } from "./FreeholdProperties/PropertyIDs";
import { hideLoading } from "@my-dld/utils/UIUtils";


export interface ILoader {
	setLoading: ( isLoading: boolean ) => void;
}

export interface IDashboardTabComponent<P, S> extends Component<P, S> {
	// doLogin: (loader: ILoader) => Promise<{ method: string, id: string, result: IdentityEntity.AuthResult }>;
}

export interface IDashboardTabComponentClass<P, S> {
	new( props: P, context?: any ): IDashboardTabComponent<P, S>;
}

interface Props extends RoutedViewProps {

}

interface State {
	isTabuUser: boolean;
	showFreeholdMessage?: boolean;
	timer?: any;
}

class Dashboard extends Component<Props, State> {

	constructor( props: Props ) {
		super( props );
		this.state = {
			isTabuUser: TabuProfile.getProfile() != undefined,
			showFreeholdMessage: false,
			timer: undefined,
		};
	}
	componentDidMount(): void {
		// this.interval = setInterval(this.checkLoadedProperties, 1000);
		this.setState({ timer: setInterval(() => (this.checkLoadedProperties()), 1000) });
	}

	checkLoadedProperties = () => {
		const store = getAppServices().storeService.getStore();
		if ( store.getState().UserData.properties ) {
			store.getState().UserData.properties?.map((p) => {
				if (propertiesId.includes(p.tabuPropertyId)) {
					this.setState({showFreeholdMessage: true});
				}
			});
		}
	}

	componentWillUnmount() {
		clearInterval(this.state.timer);
	}

    onTWIMC = ( e: MouseEvent<HTMLAnchorElement > ) => {
        e.preventDefault();
        navigate("/mydld/taburequest/twimc");
    };

	render() {
		const { isTabuUser } = this.state;
        return <section className={"mydld-section" + (isTabuUser ? "" : " business-user-dashboard")}>
            {isTabuUser && <div className="container">
                <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="navd-sidebar">
                                <ul className="nav nav-tabs nav-tab-list" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <PersonalInfo />
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active" id="myPortfolio-tab" data-bs-toggle="tab" data-bs-target="#myPortfolio-tab-pane"
                                            type="button" role="tab" aria-controls="myPortfolio-tab-pane" aria-selected="true">
                                            <i className="icon-my-portfolio"></i>
                                            {Strings.my_portfolio}
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link" id="propertyServices-tab" data-bs-toggle="tab" data-bs-target="#propertyServices-tab-pane"
                                            type="button" role="tab" aria-controls="propertyServices-tab-pane" aria-selected="false">
                                            <i className="icon-property-services"></i>
                                            {Strings.property_services}
                                            <span className="badge">9</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link" id="myRequests-tab" data-bs-toggle="tab" data-bs-target="#myRequests-tab-pane"
                                            type="button" role="tab" aria-controls="myRequests-tab-pane" aria-selected="true">
                                            <i className="icon-my-requests"></i>
                                            {Strings.my_requests}
                                            <span className="badge">4</span>
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a href="#" className="nav-link" onClick={this.onTWIMC}>
                                            <i className="icon-to-whom-it-may-concern"></i>
                                            {Strings.to_whom_it_may_concern}
                                        </a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button type="button" className="nav-link">
                                            <i className="icon-green-list"></i>
                                            {Strings.green_list}
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button type="button" className="nav-link">
                                            <i className="icon-first-time-home-buyer"></i>
                                            First Time Home Buyer
                                        </button>
                                    </li>
                                </ul>
                                <ul className="nav nav-tabs nav-tab-bottom">
                                    
                                    {this.state.showFreeholdMessage && <li className="nav-item"><div className="alert text-danger max-content gap-2 d-flex align-items-center px-0 py-2">
                                            <i className="fas fa-info-circle fs-6"></i> {Strings.important_info} <a
                                                href="#" className="underline mx-2" data-bs-toggle="modal" data-bs-target="#msgFreeholdProperty" onClick={() => {
                                                    setTimeout(() => {
                                                        JQModal("msgFreeholdProperty").show();
                                                    }, 200);
                                                }}>{Strings.view_details}</a>
                                    </div> </li>}
                                <li className="nav-item">
                                    <button className="nav-link"type="button">
                                        <i className="icon-msupport"></i>
                                        {Strings.support_label}
                                    </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-6 col-sm-12 col-12">
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="myPortfolio-tab-pane" role="tabpanel" aria-labelledby="myPortfolio-tab">

                                    <Portfolio/>
                                    <ProfileUpdatedPopup/>
                                </div>
                                <div className="tab-pane fade" id="propertyServices-tab-pane" role="tabpanel" aria-labelledby="propertyServices-tab">
                                    <PropertyServices/>
                                </div>
                                <div className="tab-pane fade" id="myRequests-tab-pane" role="tabpanel" aria-labelledby="myRequests-tab">
                                    <MyRequestsServices/>
                                </div>
                            </div>
                        </div>
					{ this.state.showFreeholdMessage &&
					<FreeholdPropertiesPopUp
						refNumber={ "123456" } onHomePressed={ () => {
						navigate( "/mydld" );
					} }/> }
                </div>
            </div>}
	        { !isTabuUser && <MyApps/> }
		</section>;
	}
}

export default Dashboard;
